import {Injectable} from '@angular/core';
import {LoanDetailsService} from '../service/loan-details.service';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class LoanIdResolver implements Resolve<string> {
    private readonly router: Router;
    private readonly loanDetailsService: LoanDetailsService;

    constructor(loanDetailsService: LoanDetailsService, router: Router) {
        this.loanDetailsService = loanDetailsService;
        this.router = router;
    }

    public async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<string> {
        const loanApplicationId = route.params['applicationId'];
        try {
            const loanDetails = await this.loanDetailsService.getLoanDetailsByApplicationId(loanApplicationId);
            return loanDetails._id;
        } catch (err) {
            await this.router.navigateByUrl('/borrow/dashboard/applications');
        }
    }
}